export * from './menu-layout';
export * from './count-badge';



import { CountBadgeComponent } from './count-badge';
import { MenuLayoutComponent } from './menu-layout';


export const LayoutAtoms = [
    MenuLayoutComponent,
    CountBadgeComponent
]